webpackJsonp([1],{

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


L.HeatLayer = (L.Layer ? L.Layer : L.Class).extend({

    // options: {
    //     minOpacity: 0.05,
    //     maxZoom: 18,
    //     radius: 25,
    //     blur: 15,
    //     max: 1.0
    // },

    initialize: function (latlngs, options) {
        this._latlngs = latlngs;
        L.setOptions(this, options);
    },

    setLatLngs: function (latlngs) {
        this._latlngs = latlngs;
        return this.redraw();
    },

    addLatLng: function (latlng) {
        this._latlngs.push(latlng);
        return this.redraw();
    },

    setOptions: function (options) {
        L.setOptions(this, options);
        if (this._heat) {
            this._updateOptions();
        }
        return this.redraw();
    },

    redraw: function () {
        if (this._heat && !this._frame && this._map && !this._map._animating) {
            this._frame = L.Util.requestAnimFrame(this._redraw, this);
        }
        return this;
    },

    onAdd: function (map) {
        this._map = map;

        if (!this._canvas) {
            this._initCanvas();
        }

        if (this.options.pane) {
            this.getPane().appendChild(this._canvas);
        }else{
            map._panes.overlayPane.appendChild(this._canvas);
        }

        map.on('moveend', this._reset, this);

        if (map.options.zoomAnimation && L.Browser.any3d) {
            map.on('zoomanim', this._animateZoom, this);
        }

        this._reset();
    },

    onRemove: function (map) {
        if (this.options.pane) {
            this.getPane().removeChild(this._canvas);
        }else{
            map.getPanes().overlayPane.removeChild(this._canvas);
        }

        map.off('moveend', this._reset, this);

        if (map.options.zoomAnimation) {
            map.off('zoomanim', this._animateZoom, this);
        }
    },

    addTo: function (map) {
        map.addLayer(this);
        return this;
    },

    _initCanvas: function () {
        var canvas = this._canvas = L.DomUtil.create('canvas', 'leaflet-heatmap-layer leaflet-layer');

        var originProp = L.DomUtil.testProp(['transformOrigin', 'WebkitTransformOrigin', 'msTransformOrigin']);
        canvas.style[originProp] = '50% 50%';

        var size = this._map.getSize();
        canvas.width  = size.x;
        canvas.height = size.y;

        var animated = this._map.options.zoomAnimation && L.Browser.any3d;
        L.DomUtil.addClass(canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));

        this._heat = simpleheat(canvas);
        this._updateOptions();
    },

    _updateOptions: function () {
        this._heat.radius(this.options.radius || this._heat.defaultRadius, this.options.blur);

        if (this.options.gradient) {
            this._heat.gradient(this.options.gradient);
        }
        if (this.options.max) {
            this._heat.max(this.options.max);
        }
    },

    _reset: function () {
        var topLeft = this._map.containerPointToLayerPoint([0, 0]);
        L.DomUtil.setPosition(this._canvas, topLeft);

        var size = this._map.getSize();

        if (this._heat._width !== size.x) {
            this._canvas.width = this._heat._width  = size.x;
        }
        if (this._heat._height !== size.y) {
            this._canvas.height = this._heat._height = size.y;
        }

        this._redraw();
    },

    _redraw: function () {
        if (!this._map) {
            return;
        }
        var data = [],
            r = this._heat._r,
            size = this._map.getSize(),
            bounds = new L.Bounds(
                L.point([-r, -r]),
                size.add([r, r])),

            max = this.options.max === undefined ? 1 : this.options.max,
            maxZoom = this.options.maxZoom === undefined ? this._map.getMaxZoom() : this.options.maxZoom,
            v = 1 / Math.pow(2, Math.max(0, Math.min(maxZoom - this._map.getZoom(), 12))),
            cellSize = r / 2,
            grid = [],
            panePos = this._map._getMapPanePos(),
            offsetX = panePos.x % cellSize,
            offsetY = panePos.y % cellSize,
            i, len, p, cell, x, y, j, len2, k;

        // console.time('process');
        for (i = 0, len = this._latlngs.length; i < len; i++) {
            p = this._map.latLngToContainerPoint(this._latlngs[i]);
            if (bounds.contains(p)) {
                x = Math.floor((p.x - offsetX) / cellSize) + 2;
                y = Math.floor((p.y - offsetY) / cellSize) + 2;

                var alt =
                    this._latlngs[i].alt !== undefined ? this._latlngs[i].alt :
                    this._latlngs[i][2] !== undefined ? +this._latlngs[i][2] : 1;
                k = alt * v;

                grid[y] = grid[y] || [];
                cell = grid[y][x];

                if (!cell) {
                    grid[y][x] = [p.x, p.y, k];

                } else {
                    cell[0] = (cell[0] * cell[2] + p.x * k) / (cell[2] + k); // x
                    cell[1] = (cell[1] * cell[2] + p.y * k) / (cell[2] + k); // y
                    cell[2] += k; // cumulated intensity value
                }
            }
        }

        for (i = 0, len = grid.length; i < len; i++) {
            if (grid[i]) {
                for (j = 0, len2 = grid[i].length; j < len2; j++) {
                    cell = grid[i][j];
                    if (cell) {
                        data.push([
                            Math.round(cell[0]),
                            Math.round(cell[1]),
                            Math.min(cell[2], max)
                        ]);
                    }
                }
            }
        }
        // console.timeEnd('process');

        // console.time('draw ' + data.length);
        this._heat.data(data).draw(this.options.minOpacity);
        // console.timeEnd('draw ' + data.length);

        this._frame = null;
    },

    _animateZoom: function (e) {
        var scale = this._map.getZoomScale(e.zoom),
            offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());

        if (L.DomUtil.setTransform) {
            L.DomUtil.setTransform(this._canvas, offset, scale);

        } else {
            this._canvas.style[L.DomUtil.TRANSFORM] = L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ')';
        }
    }
});

L.heatLayer = function (latlngs, options) {
    return new L.HeatLayer(latlngs, options);
};


/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(162);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_stations__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_pointStore__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tide_api__ = __webpack_require__(30);






var Promise = __webpack_require__(32);
var moment = __webpack_require__(0);

var dataModel = function () {
  function dataModel() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, dataModel);

    this.measurePromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__model_stations__["a" /* measureLocations */])();
    this.rainStorePromise = this.measurePromise.then(function (locations) {
      return new __WEBPACK_IMPORTED_MODULE_3__model_pointStore__["a" /* default */](90000, __WEBPACK_IMPORTED_MODULE_4__services_tide_api__["a" /* rainReadings */], locations);
    });
    this.tideStorePromise = this.measurePromise.then(function (locations) {
      return new __WEBPACK_IMPORTED_MODULE_3__model_pointStore__["a" /* default */](30000, __WEBPACK_IMPORTED_MODULE_4__services_tide_api__["b" /* tideReadings */], locations);
    });
    this.levelStorePromise = this.measurePromise.then(function (locations) {
      return new __WEBPACK_IMPORTED_MODULE_3__model_pointStore__["a" /* default */](250000, __WEBPACK_IMPORTED_MODULE_4__services_tide_api__["c" /* riverReadings */], locations);
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(dataModel, [{
    key: 'getLatest',
    value: function getLatest(requiredType) {
      var rainPromise = Promise.resolve([]);
      var tidePromise = Promise.resolve([]);
      var floodingPromise = Promise.resolve([]);
      if (requiredType) {
        if (requiredType.rainfall) {
          rainPromise = this.rainStorePromise.then(function (store) {
            return store.getLatest();
          });
        }
        if (requiredType.flooding) {
          floodingPromise = this.levelStorePromise.then(function (store) {
            return store.getLatest();
          });
        }
        if (requiredType.tide) {
          tidePromise = this.tideStorePromise.then(function (store) {
            return store.getLatest();
          });
        }
      }
      return Promise.join(floodingPromise, rainPromise, tidePromise, function (levelPoints, rainPoints, tidePoints) {
        return { levelPoints: levelPoints, rainPoints: rainPoints, tidePoints: tidePoints };
      });
    }
  }, {
    key: 'getDate',
    value: function getDate(date, requiredType) {
      var loadPromises = {};
      if (requiredType) {
        if (requiredType.rainfall) {
          loadPromises.rain = {
            promise: this.rainStorePromise.then(function (store) {
              return store.getDay(date);
            }),
            type: 'rainfall'
          };
        }
        if (requiredType.flooding) {
          loadPromises.level = {
            promise: this.levelStorePromise.then(function (store) {
              return store.getDay(date);
            }),
            type: 'flooding'
          };
        }
        if (requiredType.tide) {
          loadPromises.tide = {
            promise: this.tideStorePromise.then(function (store) {
              return store.getDay(date);
            }),
            type: 'tide'
          };
        }
      }
      return loadPromises;
    }
  }, {
    key: 'getAPIPoint',
    value: function getAPIPoint(date, time, requiredType) {
      var floodingPromise = Promise.resolve([]);
      var rainPromise = Promise.resolve([]);
      var tidePromise = Promise.resolve([]);
      if (requiredType.rainfall) {
        rainPromise = this.rainStorePromise.then(function (rain) {
          return rain.getPoint(moment(date + ' ' + time, 'YYYY-MM-DD HH-mm').add(1, 'hour').format('YYYY-MM-DD HH-mm'));
        });
      }
      if (requiredType.flooding) {
        floodingPromise = this.levelStorePromise.then(function (levels) {
          return levels.getPoint(moment(date + ' ' + time, 'YYYY-MM-DD HH-mm').add(1, 'hour').format('YYYY-MM-DD HH-mm'));
        });
      }
      if (requiredType.tide) {
        tidePromise = this.tideStorePromise.then(function (tides) {
          return tides.getPoint(moment(date + ' ' + time, 'YYYY-MM-DD HH-mm').add(1, 'hour').format('YYYY-MM-DD HH-mm'));
        });
      }
      return Promise.join(rainPromise, floodingPromise, tidePromise, function (rainPoints, levelPoints, tidePoints) {
        return {
          rainPoints: rainPoints, levelPoints: levelPoints, tidePoints: tidePoints };
      });
    }
  }]);

  return dataModel;
}();

/* harmony default export */ __webpack_exports__["a"] = (dataModel);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var DataPoint = function () {
  function DataPoint(json) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataPoint);

    this.jsonRef = json;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DataPoint, [{
    key: 'lat',
    value: function lat() {
      return this.get('lat');
    }
  }, {
    key: 'long',
    value: function long() {
      return this.get('long');
    }
  }, {
    key: 'value',
    value: function value() {
      return parseFloat(this.get('value'));
    }
  }, {
    key: 'get',
    value: function get(path) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.jsonRef, path);
    }
  }]);

  return DataPoint;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataPoint);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_stations__ = __webpack_require__(29);






var _ = __webpack_require__(7);

var API_READING_LIMIT = 10000;

function binReadings(readings) {
  var bins = {};
  readings.map(function (reading) {
    if (bins[reading.moment()]) {
      bins[reading.moment()].push(reading);
    } else {
      bins[reading.moment()] = [reading];
    }
    return null;
  });
  return bins;
}

var PointStore = function () {
  function PointStore(limit, getterFunction, locations) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PointStore);

    this.limit = limit;
    this.getterFunction = getterFunction;
    this.points = {};
    this.loadingDays = [];
    this.locations = locations;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PointStore, [{
    key: 'getDay',
    value: function getDay(date) {
      var _this = this;

      var completionPromise = void 0;
      var pagePromises = [];
      if (!this.loadingDays[date]) {
        this.loadingDays[date] = true;
        for (var i = 0; i < this.limit; i += API_READING_LIMIT) {
          pagePromises.push(this.getterFunction({ date: date, '_offset': i }));
        }
        completionPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(pagePromises).then(function (pages) {
          return pages.reduce(function (all, page) {
            return all.concat(page);
          }, []);
        }).then(function (readings) {
          return binReadings(readings);
        }).then(function (binnedReadings) {
          var dataPointsByDatetime = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(binnedReadings).map(function (key) {
            dataPointsByDatetime[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_stations__["b" /* readingArrayToDataPoints */])(_this.locations, binnedReadings[key]);
            return null;
          });
          return dataPointsByDatetime;
        }).then(function (dataPoints) {
          _this.points = _.extend(_this.points, dataPoints);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve('complete');
        });
      } else {
        completionPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve('already polled');
      }
      return {
        total: this.limit / API_READING_LIMIT,
        pagePromises: pagePromises,
        completionPromise: completionPromise
      };
    }
  }, {
    key: 'getLatest',
    value: function getLatest() {
      var _this2 = this;

      return this.getterFunction({ latest: '' }).then(function (readings) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_stations__["b" /* readingArrayToDataPoints */])(_this2.locations, readings);
      });
    }
  }, {
    key: 'getPoint',
    value: function getPoint(date) {
      var pointPromise = void 0;
      if (this.points[date]) {
        pointPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.points[date]);
      } else {
        pointPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
      }
      return pointPromise;
    }
  }]);

  return PointStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PointStore);

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export READINGS_DATE_FORMAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





var READINGS_DATE_FORMAT = 'D MMM YYYY';

var Reading = function () {
  function Reading(json) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Reading);

    this.jsonRef = json;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Reading, [{
    key: 'uri',
    value: function uri() {
      return this.get('@id');
    }
  }, {
    key: 'value',
    value: function value() {
      return this.get('value');
    }
  }, {
    key: 'dateTimeStr',
    value: function dateTimeStr() {
      return this.get('dateTime');
    }
  }, {
    key: 'moment',
    value: function moment() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateTimeStr()).format('YYYY-MM-DD HH-mm');
    }
  }, {
    key: 'dateTime',
    value: function dateTime() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateTimeStr()).utc();
    }
  }, {
    key: 'measure',
    value: function measure() {
      return this.get('measure');
    }
  }, {
    key: 'jsDate',
    value: function jsDate() {
      return this.dateTime().toDate();
    }
  }, {
    key: 'get',
    value: function get(path) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.jsonRef, path);
    }
  }]);

  return Reading;
}();

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Station; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Station = function () {
  function Station(json) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Station);

    this.json = json;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Station, [{
    key: 'riverName',
    value: function riverName() {
      return this.get('riverName');
    }
  }, {
    key: 'lat',
    value: function lat() {
      return this.get('lat');
    }
  }, {
    key: 'long',
    value: function long() {
      return this.get('long');
    }
  }, {
    key: 'reference',
    value: function reference() {
      return this.get('stationReference');
    }
  }, {
    key: 'measure',
    value: function measure() {
      var measures = [];
      if (this.get('measures')) {
        measures = this.get('measures');
      }
      return measures;
    }
  }, {
    key: 'get',
    value: function get(path) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.json, path);
    }
  }]);

  return Station;
}();



/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


__webpack_require__(216);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'form',
  props: ['latest', 'day'],
  data: function data() {
    return {
      date: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      flooding: false,
      rainfall: false,
      tide: false,
      floodProgress: '',
      rainProgress: '',
      tideProgress: '',
      min: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      max: moment().format('YYYY-MM-DD')
    };
  },
  computed: function computed() {
    return {
      flooding: this.flooding,
      rainfall: this.rainfall,
      tide: this.tide
    };
  },

  methods: {
    update: function update() {
      this.$emit('input', {
        flooding: this.flooding,
        rainfall: this.rainfall,
        tide: this.tide,
        date: this.date
      });
    },
    toggleLoad: function toggleLoad(toToggle) {
      if (toToggle.flooding) {
        var floodload = document.getElementById('floodload');
        if (toToggle.flooding === 'fail') {
          this.floodProgress = 'Failed';
        } else {
          floodload.classList.toggle('notloading');
          this.floodProgress = '';
        }
      }
      if (toToggle.rainfall) {
        var rainload = document.getElementById('rainload');
        if (toToggle.rainfall === 'fail') {
          this.rainProgress = 'Failed';
        } else {
          rainload.classList.toggle('notloading');
          this.rainProgress = '';
        }
      }
      if (toToggle.tide) {
        var tideload = document.getElementById('tideload');
        if (toToggle.tide === 'fail') {
          this.rainProgress = 'Failed';
        } else {
          tideload.classList.toggle('notloading');
          this.tideProgress = '';
        }
      }
    },
    loadingPercent: function loadingPercent(percentObj) {
      if (percentObj.flooding) {
        this.floodProgress = Math.floor(percentObj.flooding * 100) + '%';
      }
      if (percentObj.rainfall) {
        this.rainProgress = Math.floor(percentObj.rainfall * 100) + '%';
      }
      if (percentObj.tide) {
        this.tideProgress = Math.floor(percentObj.tide * 100) + '%';
      }
    }
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataForm__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timestamp__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timestamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__timestamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_dataModel__ = __webpack_require__(167);








var moment = __webpack_require__(0);

var dataModel = new __WEBPACK_IMPORTED_MODULE_4__model_dataModel__["a" /* default */]();
var rainOptions = { color: 'blue', weight: 1 };
var tideOptions = {
  color: 'red',
  weight: 1,
  marker: { color: 'red', width: 10 }
};

function nearestQuarterHour() {
  var quarters = Math.floor(moment().minute() / 15) * 15;
  return moment().set('minute', quarters).format('HH-mm');
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      time: nearestQuarterHour(),
      flooding: true,
      rainfall: true,
      tide: true,
      latest: true,
      day: false
    };
  },

  components: {
    MapView: __WEBPACK_IMPORTED_MODULE_1__Map___default.a,
    timestamp: __WEBPACK_IMPORTED_MODULE_3__timestamp___default.a,
    DataForm: __WEBPACK_IMPORTED_MODULE_2__DataForm___default.a
  },
  mounted: function mounted() {
    this.checkdate();
  },

  watch: {
    date: function date() {
      dataModel.getDate(this.date, this.getSelected());
    }
  },
  methods: {
    getSelected: function getSelected() {
      return {
        flooding: this.flooding,
        tide: this.tide,
        rainfall: this.rainfall
      };
    },
    setData: function setData(formData) {
      var _this = this;

      this.flooding = formData.flooding;
      this.rainfall = formData.rainfall;
      this.tide = formData.tide;
      this.latest = false;
      this.day = true;
      this.pause();
      var datePromises = dataModel.getDate(formData.date, this.getSelected());
      this.$refs.form.toggleLoad(this.getSelected());
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datePromises).map(function (key) {
        return datePromises[key].promise.then(function (out) {
          var done = 0;
          var total = out.total;
          out.completionPromise.then(function () {
            var loadObj = {};
            loadObj[datePromises[key].type] = true;
            _this.$refs.form.toggleLoad(loadObj);
            _this.time = '00-00';
            _this.date = formData.date;
            _this.play();
            _this.checkdate();
            return null;
          }).catch(function () {
            var loadObj = {};
            loadObj[datePromises[key].type] = 'fail';
            _this.$refs.form.toggleLoad(loadObj);
          });
          out.pagePromises.map(function (promise) {
            return promise.then(function () {
              done += 1;
              var loadObj = {};
              loadObj[datePromises[key].type] = done / total;
              _this.$refs.form.loadingPercent(loadObj);
            });
          });
        });
      });
    },
    play: function play() {
      var _this2 = this;

      this.$refs.time.setStart();
      if (!this.intervalId) {
        this.intervalId = window.setInterval(function () {
          _this2.date = moment(_this2.date, 'YYYY-MM-DD').format('YYYY-MM-DD');
          _this2.time = moment(_this2.time, 'HH-mm').add(15, 'minutes').format('HH-mm');
          _this2.checkdate(_this2.date, _this2.time);
          _this2.$refs.time.setStart();
        }, 50);
      }
    },
    pause: function pause() {
      this.intervalId = window.clearInterval(this.intervalId);
    },
    skipfwd: function skipfwd() {
      this.time = moment(this.time, 'HH-mm').add(15, 'minutes').format('HH-mm');
      this.checkdate();
    },
    skipback: function skipback() {
      this.time = moment(this.time, 'HH-mm').subtract(15, 'minutes').format('HH-mm');
      this.checkdate();
    },
    checkdate: function checkdate() {
      var _this3 = this;

      var valuePromises = void 0;
      if (this.latest) {
        valuePromises = dataModel.getLatest(this.getSelected());
      } else if (this.day) {
        valuePromises = dataModel.getAPIPoint(this.date, this.time, this.getSelected());
      }
      return valuePromises.then(function (values) {
        var data = {
          rainData: { data: values.rainPoints, options: rainOptions },
          levelData: { data: values.levelPoints, options: {} },
          tideData: { data: values.tidePoints, options: tideOptions }
        };
        if (_this3.$refs) {
          _this3.$refs.leaflet.pointsUpdate(data);
        }
      });
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {



var L = __webpack_require__(222);
__webpack_require__(165);

var _ = __webpack_require__(7);

var mapRef = {};
var rainLayer = void 0;
var floodLayer = void 0;
var tideLayer = void 0;

function mapGraph(data) {
  var zoom = mapRef.getZoom();
  var scale = 1 / zoom;
  var marker = _.extend({ radius: 3 }, data.options.marker);
  var params = _.extend({}, data.options);
  if (data) {
    var locationPoints = data.data.reduce(function (result, point) {
      if (point.value() > 0) {
        result.push(L.circleMarker([point.lat(), point.long()], marker));
      }
      return result;
    }, []);
    var features = data.data.reduce(function (result, point) {
      if (point.value() > 0) {
        var locations = [[point.lat(), point.long()], [point.lat() + point.value() * scale, point.long()]];
        result.push(L.polyline(locations, params));
      }
      return result;
    }, locationPoints);
    return L.featureGroup(features);
  }
  return new L.LayerGroup();
}

function heatMap(data) {
  var params = _.extend({ radius: 10, blur: 40 }, data.options);
  if (data) {
    var pointlocation = data.data.map(function (point) {
      return [point.lat(), point.long(), point.value() * 10];
    });
    return L.heatLayer(pointlocation, params);
  }
  return new L.LayerGroup();
}

module.exports = {
  name: 'MapView',
  mounted: function mounted() {
    mapRef = L.map('mapid').setView(new L.LatLng(52, -2), 7);

    var osmUrl = '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    var osmAttrib = "Map data © <a href='//openstreetmap.org'>OpenStreetMap</a> contributors";
    var osm = new L.TileLayer(osmUrl, {
      minZoom: 0, maxZoom: 12, attribution: osmAttrib
    });

    mapRef.addLayer(osm);
    rainLayer = new L.LayerGroup().addTo(mapRef);
    floodLayer = new L.LayerGroup().addTo(mapRef);
    tideLayer = new L.LayerGroup().addTo(mapRef);
  },

  methods: {
    pointsUpdate: function pointsUpdate(newData) {
      var tempRainLayer = mapGraph(newData.rainData);
      var tempFloodLayer = heatMap(newData.levelData);
      var tempTideLayer = mapGraph(newData.tideData);
      tempRainLayer.addTo(mapRef);
      tempFloodLayer.addTo(mapRef);
      tempTideLayer.addTo(mapRef);
      rainLayer.remove();
      floodLayer.remove();
      tideLayer.remove();
      floodLayer = tempRainLayer;
      rainLayer = tempFloodLayer;
      tideLayer = tempTideLayer;
    },
    clear: function clear(dataTypes) {
      if (dataTypes.rainData) {
        rainLayer.remove();
      }
      if (dataTypes.levelData) {
        floodLayer.remove();
      }
    }
  }
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {



var moment = __webpack_require__(0);

module.exports = {
  name: 'timestamp',
  data: function data() {
    return {
      playerStatus: '',
      playing: false
    };
  },

  computed: {
    datestring: function datestring() {
      return moment(this.date + ' ' + this.time, 'YYYY-MM-DD HH-mm').format('MMMM Do YYYY, HH:mm');
    }
  },
  methods: {
    setStart: function setStart() {
      if (this.playerStatus === '') {
        document.getElementById('playbackholder').classList.toggle('hidden');
        this.playerStatus = '▮▮';
        this.playing = true;
      }
    },
    togglePause: function togglePause() {
      if (!this.playing) {
        document.getElementById('play').classList.toggle('fa-pause');
        document.getElementById('play').classList.toggle('fa-play');
        this.playerStatus = '▮▮';
        this.playing = true;
        this.$emit('play');
      } else {
        document.getElementById('play').classList.toggle('fa-play');
        document.getElementById('play').classList.toggle('fa-pause');
        this.playing = false;
        this.$emit('pause');
      }
    },
    skipback: function skipback() {
      this.$emit('skipback');
    },
    skipfwd: function skipfwd() {
      this.$emit('skipfwd');
    }
  },
  props: ['date', 'time']
};

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 45,
	"./af.js": 45,
	"./ar": 52,
	"./ar-dz": 46,
	"./ar-dz.js": 46,
	"./ar-kw": 47,
	"./ar-kw.js": 47,
	"./ar-ly": 48,
	"./ar-ly.js": 48,
	"./ar-ma": 49,
	"./ar-ma.js": 49,
	"./ar-sa": 50,
	"./ar-sa.js": 50,
	"./ar-tn": 51,
	"./ar-tn.js": 51,
	"./ar.js": 52,
	"./az": 53,
	"./az.js": 53,
	"./be": 54,
	"./be.js": 54,
	"./bg": 55,
	"./bg.js": 55,
	"./bn": 56,
	"./bn.js": 56,
	"./bo": 57,
	"./bo.js": 57,
	"./br": 58,
	"./br.js": 58,
	"./bs": 59,
	"./bs.js": 59,
	"./ca": 60,
	"./ca.js": 60,
	"./cs": 61,
	"./cs.js": 61,
	"./cv": 62,
	"./cv.js": 62,
	"./cy": 63,
	"./cy.js": 63,
	"./da": 64,
	"./da.js": 64,
	"./de": 67,
	"./de-at": 65,
	"./de-at.js": 65,
	"./de-ch": 66,
	"./de-ch.js": 66,
	"./de.js": 67,
	"./dv": 68,
	"./dv.js": 68,
	"./el": 69,
	"./el.js": 69,
	"./en-au": 70,
	"./en-au.js": 70,
	"./en-ca": 71,
	"./en-ca.js": 71,
	"./en-gb": 72,
	"./en-gb.js": 72,
	"./en-ie": 73,
	"./en-ie.js": 73,
	"./en-nz": 74,
	"./en-nz.js": 74,
	"./eo": 75,
	"./eo.js": 75,
	"./es": 77,
	"./es-do": 76,
	"./es-do.js": 76,
	"./es.js": 77,
	"./et": 78,
	"./et.js": 78,
	"./eu": 79,
	"./eu.js": 79,
	"./fa": 80,
	"./fa.js": 80,
	"./fi": 81,
	"./fi.js": 81,
	"./fo": 82,
	"./fo.js": 82,
	"./fr": 85,
	"./fr-ca": 83,
	"./fr-ca.js": 83,
	"./fr-ch": 84,
	"./fr-ch.js": 84,
	"./fr.js": 85,
	"./fy": 86,
	"./fy.js": 86,
	"./gd": 87,
	"./gd.js": 87,
	"./gl": 88,
	"./gl.js": 88,
	"./gom-latn": 89,
	"./gom-latn.js": 89,
	"./he": 90,
	"./he.js": 90,
	"./hi": 91,
	"./hi.js": 91,
	"./hr": 92,
	"./hr.js": 92,
	"./hu": 93,
	"./hu.js": 93,
	"./hy-am": 94,
	"./hy-am.js": 94,
	"./id": 95,
	"./id.js": 95,
	"./is": 96,
	"./is.js": 96,
	"./it": 97,
	"./it.js": 97,
	"./ja": 98,
	"./ja.js": 98,
	"./jv": 99,
	"./jv.js": 99,
	"./ka": 100,
	"./ka.js": 100,
	"./kk": 101,
	"./kk.js": 101,
	"./km": 102,
	"./km.js": 102,
	"./kn": 103,
	"./kn.js": 103,
	"./ko": 104,
	"./ko.js": 104,
	"./ky": 105,
	"./ky.js": 105,
	"./lb": 106,
	"./lb.js": 106,
	"./lo": 107,
	"./lo.js": 107,
	"./lt": 108,
	"./lt.js": 108,
	"./lv": 109,
	"./lv.js": 109,
	"./me": 110,
	"./me.js": 110,
	"./mi": 111,
	"./mi.js": 111,
	"./mk": 112,
	"./mk.js": 112,
	"./ml": 113,
	"./ml.js": 113,
	"./mr": 114,
	"./mr.js": 114,
	"./ms": 116,
	"./ms-my": 115,
	"./ms-my.js": 115,
	"./ms.js": 116,
	"./my": 117,
	"./my.js": 117,
	"./nb": 118,
	"./nb.js": 118,
	"./ne": 119,
	"./ne.js": 119,
	"./nl": 121,
	"./nl-be": 120,
	"./nl-be.js": 120,
	"./nl.js": 121,
	"./nn": 122,
	"./nn.js": 122,
	"./pa-in": 123,
	"./pa-in.js": 123,
	"./pl": 124,
	"./pl.js": 124,
	"./pt": 126,
	"./pt-br": 125,
	"./pt-br.js": 125,
	"./pt.js": 126,
	"./ro": 127,
	"./ro.js": 127,
	"./ru": 128,
	"./ru.js": 128,
	"./sd": 129,
	"./sd.js": 129,
	"./se": 130,
	"./se.js": 130,
	"./si": 131,
	"./si.js": 131,
	"./sk": 132,
	"./sk.js": 132,
	"./sl": 133,
	"./sl.js": 133,
	"./sq": 134,
	"./sq.js": 134,
	"./sr": 136,
	"./sr-cyrl": 135,
	"./sr-cyrl.js": 135,
	"./sr.js": 136,
	"./ss": 137,
	"./ss.js": 137,
	"./sv": 138,
	"./sv.js": 138,
	"./sw": 139,
	"./sw.js": 139,
	"./ta": 140,
	"./ta.js": 140,
	"./te": 141,
	"./te.js": 141,
	"./tet": 142,
	"./tet.js": 142,
	"./th": 143,
	"./th.js": 143,
	"./tl-ph": 144,
	"./tl-ph.js": 144,
	"./tlh": 145,
	"./tlh.js": 145,
	"./tr": 146,
	"./tr.js": 146,
	"./tzl": 147,
	"./tzl.js": 147,
	"./tzm": 149,
	"./tzm-latn": 148,
	"./tzm-latn.js": 148,
	"./tzm.js": 149,
	"./uk": 150,
	"./uk.js": 150,
	"./ur": 151,
	"./ur.js": 151,
	"./uz": 153,
	"./uz-latn": 152,
	"./uz-latn.js": 152,
	"./uz.js": 153,
	"./vi": 154,
	"./vi.js": 154,
	"./x-pseudo": 155,
	"./x-pseudo.js": 155,
	"./yo": 156,
	"./yo.js": 156,
	"./zh-cn": 157,
	"./zh-cn.js": 157,
	"./zh-hk": 158,
	"./zh-hk.js": 158,
	"./zh-tw": 159,
	"./zh-tw.js": 159
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8769ca82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-115c0d71",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abaf4a8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19c05055",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('MapView', {
    ref: "leaflet"
  }), _vm._v(" "), _c('DataForm', {
    ref: "form",
    on: {
      "input": _vm.setData
    }
  }), _vm._v(" "), _c('timestamp', {
    ref: "time",
    attrs: {
      "date": _vm.date,
      "time": _vm.time
    },
    on: {
      "skipfwd": _vm.skipfwd,
      "skipback": _vm.skipback,
      "pause": _vm.pause,
      "play": _vm.play
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('span', {
    staticClass: "hidden",
    attrs: {
      "id": "playbackholder"
    }
  }, [_c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.skipback
    }
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.togglePause
    }
  }, [_c('i', {
    staticClass: "fa icon-fixed-width fa-pause",
    attrs: {
      "id": "play",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.skipfwd
    }
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.datestring))])])
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prompt"
  }, [_c('div', [_vm._v("\n    Select a date and data to display\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "dateBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    attrs: {
      "type": "date",
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dataTypes"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tide),
      expression: "tide"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tide) ? _vm._i(_vm.tide, null) > -1 : (_vm.tide)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.tide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.tide = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.tide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tide = $$c
        }
      }
    }
  }), _vm._v("\n        Tide\n        "), _c('span', {
    staticClass: "notloading load",
    attrs: {
      "id": "tideload"
    }
  }, [_vm._v("\n          Loading " + _vm._s(_vm.tideProgress) + "\n        ")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rainfall),
      expression: "rainfall"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rainfall) ? _vm._i(_vm.rainfall, null) > -1 : (_vm.rainfall)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rainfall,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.rainfall = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rainfall = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rainfall = $$c
        }
      }
    }
  }), _vm._v("\n        Rainfall\n        "), _c('span', {
    staticClass: "notloading load",
    attrs: {
      "id": "rainload"
    }
  }, [_vm._v("\n          Loading " + _vm._s(_vm.rainProgress) + "\n        ")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flooding),
      expression: "flooding"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.flooding) ? _vm._i(_vm.flooding, null) > -1 : (_vm.flooding)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.flooding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.flooding = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.flooding = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flooding = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Flooding ")]), _vm._v(" "), _c('span', {
    staticClass: "notloading load",
    attrs: {
      "id": "floodload"
    }
  }, [_vm._v("\n          Loading " + _vm._s(_vm.floodProgress) + "\n        ")])])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: []}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mapid"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return measureLocations; });
/* unused harmony export stationsCollection */
/* unused harmony export latestValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return readingArrayToDataPoints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tide_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_dataPoint__ = __webpack_require__(168);



var Promise = __webpack_require__(32);

var stations = void 0;
var stationsPromise = void 0;

var measures = void 0;
var measuresPromise = void 0;

function retrieveStations() {
  stationsPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_tide_api__["d" /* allStations */])().then(function (stns) {
    stations = stns;
    stationsPromise = null;
    return stns;
  });
  return stationsPromise;
}

function stationsCollection() {
  if (stations) {
    return Promise.resolve(stations);
  } else if (stationsPromise) {
    return stationsPromise;
  }

  return retrieveStations();
}

function measureLocations() {
  var locationPromise = void 0;

  if (measures) {
    locationPromise = Promise.resolve(measures);
  } else if (measuresPromise) {
    locationPromise = measuresPromise;
  } else {
    measuresPromise = stationsCollection().then(function (stationlist) {
      var measureLocs = {};
      stationlist.map(function (station) {
        station.measure().map(function (measureVal) {
          if (!measureLocs[measureVal['@id']]) {
            measureLocs[measureVal['@id']] = {
              lat: station.lat(),
              long: station.long()
            };
          }
          return null;
        });
        return null;
      });
      measures = measureLocs;
      return measureLocs;
    });
    locationPromise = measuresPromise;
  }
  return locationPromise;
}

function getPointFromReading(reading, locations) {
  return {
    lat: locations[reading.measure()].lat,
    long: locations[reading.measure()].long,
    value: reading.value()
  };
}

function latestValues() {
  return measureLocations().then(function (locations) {
    return Promise.join(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_tide_api__["b" /* tideReadings */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_tide_api__["c" /* riverReadings */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_tide_api__["a" /* rainReadings */])(), function (tideResults, riverResults, rainResults) {
      var tide = tideResults.map(function (tidalLevel) {
        return getPointFromReading(tidalLevel, locations);
      });
      var river = riverResults.map(function (riverLevel) {
        return getPointFromReading(riverLevel, locations);
      });
      var rain = rainResults.map(function (rainLevel) {
        return getPointFromReading(rainLevel, locations);
      });
      return { tide: tide, river: river, rain: rain };
    });
  });
}

function readingArrayToDataPoints(locations, readings) {
  var dataPointsArray = [];
  if (readings) {
    dataPointsArray = readings.reduce(function (dataPoints, reading) {
      if (locations[reading.measure()]) {
        var val = getPointFromReading(reading, locations);
        if (val.lat !== undefined || val.long !== undefined) {
          dataPoints.push(new __WEBPACK_IMPORTED_MODULE_1__model_dataPoint__["a" /* default */](val));
        }
      }
      return dataPoints;
    }, []);
  }
  return dataPointsArray;
}



/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tideReadings;
/* harmony export (immutable) */ __webpack_exports__["c"] = riverReadings;
/* harmony export (immutable) */ __webpack_exports__["a"] = rainReadings;
/* harmony export (immutable) */ __webpack_exports__["d"] = allStations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_station__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_reading__ = __webpack_require__(170);



var request = __webpack_require__(225);
var _ = __webpack_require__(7);

var API_ROOT = '//environment.data.gov.uk';
var STATIONS_ENDPOINT = '/flood-monitoring/id/stations';
var READINGS_ENDPOINT = '/flood-monitoring/data/readings';

function getJSON(apiPath, params) {
  var protocol = 'https:';
  var api = '' + protocol + API_ROOT + apiPath;
  var reqPromise = request.get(api).accept('application/json').query(params || {});
  return reqPromise;
}

function wrapValues(ValueClass, items) {
  return _.map(items.body.items, function (item) {
    return new ValueClass(item);
  });
}

function tideReadings(options) {
  var params = _.extend({ qualifier: 'Tidal Level', _limit: 10000 }, options);
  return getJSON('' + READINGS_ENDPOINT, params).then(function (items) {
    return wrapValues(__WEBPACK_IMPORTED_MODULE_1__model_reading__["a" /* Reading */], items);
  });
}

function riverReadings(options) {
  var params = _.extend({ qualifier: 'Stage', _limit: 10000 }, options);
  return getJSON('' + READINGS_ENDPOINT, params).then(function (items) {
    return wrapValues(__WEBPACK_IMPORTED_MODULE_1__model_reading__["a" /* Reading */], items);
  });
}

function rainReadings(options) {
  var params = _.extend({ parameter: 'rainfall', _limit: 10000 }, options);
  return getJSON('' + READINGS_ENDPOINT, params).then(function (items) {
    return wrapValues(__WEBPACK_IMPORTED_MODULE_1__model_reading__["a" /* Reading */], items);
  });
}

function allStations(options) {
  var params = _.extend({}, options);
  return getJSON(STATIONS_ENDPOINT, params).then(function (items) {
    return wrapValues(__WEBPACK_IMPORTED_MODULE_0__model_station__["a" /* default */], items);
  });
}

/***/ })

},[166]);


// WEBPACK FOOTER //
// static/js/app.8b71080ccaa445ccc1a6.js